import { footerQuick, footerTopics } from "@/mocks/siteData";

export default function Footer() {
  return (
    <footer className="bg-background-200/80 border-t border-background-300">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12">
          <div className="col-span-2 md:col-span-1">
            <a href="#top" className="flex items-center gap-2 cursor-pointer">
              <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-primary-500 text-background-50 font-heading font-black text-lg">
                九
              </span>
              <span className="font-heading font-extrabold text-xl text-foreground-950">九色爆料</span>
            </a>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              一座靠谱、克制又有温度的娱乐资讯驿站。汇聚影视综艺、明星动态与现场演出的最新话题，让追热点这件事，更轻松也更安心。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {[
                { icon: "ri-send-plane-line", label: "订阅" },
                { icon: "ri-chat-3-line", label: "社区" },
                { icon: "ri-mail-line", label: "邮件" },
                { icon: "ri-rss-line", label: "订阅源" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href="#contact"
                  aria-label={s.label}
                  className="flex items-center justify-center w-9 h-9 rounded-lg bg-background-50 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors"
                >
                  <i className={`${s.icon} text-base w-4 h-4 flex items-center justify-center`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {footerQuick.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950 mb-4">热门栏目</h4>
            <ul className="space-y-2.5">
              {footerTopics.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950 mb-4">内容原则</h4>
            <ul className="space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-primary-600 text-base w-4 h-4 flex items-center justify-center"></i>
                来源不明不收
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-primary-600 text-base w-4 h-4 flex items-center justify-center"></i>
                客观克制表达
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-primary-600 text-base w-4 h-4 flex items-center justify-center"></i>
                尊重创作者
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-primary-600 text-base w-4 h-4 flex items-center justify-center"></i>
                全天滚动更新
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-300 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 九色爆料 · 娱乐热讯轻门户。本站内容基于公开信息来源整理，仅供资讯参考。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#about" className="hover:text-primary-600 transition-colors">关于我们</a>
            <a href="#faq" className="hover:text-primary-600 transition-colors">常见问题</a>
            <a href="#contact" className="hover:text-primary-600 transition-colors">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}